import type {
  ProductReviewsFilters,
  ProductReviewsResponse,
} from "@/features/rating/types/product-rating.type";
import { GET } from "@/lib/methods";

export const getProductReviews = async (
  productId: string,
  page: number,
  limit: number,
  filters: ProductReviewsFilters,
) => {
  const query = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
    sort: filters.sort,
  });

  if (filters.rating !== undefined) {
    query.set("rating", filters.rating.toString());
  }
  if (filters.withText) {
    query.set("withText", "true");
  }

  const response = await GET<ProductReviewsResponse>({
    url: `/api/rating/${productId}/reviews?${query.toString()}`,
  });

  return response;
};
